import { CanActivateFn } from '@angular/router';
import { AuthService } from '@nutrix/data-access-auth';
import { inject } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const adminGuard: CanActivateFn = (route, state) => {
  const usersService = inject(AuthService);
  if (usersService.loadCurrentUser()?.admin === false) {
    return false;
  }
  return true;
};
